module.exports = {
  title: '龙翼客车运营管理平台',
  baseUrl: '//10.1.41.37:7229/',
  // baseUrl: '//127.0.0.1:7237/', 
  socketServer: "ws.kingwings.cn/socket",
  //是否支持当天数据查询
  supportTodayDataQuery: true,
  routeStartTime: {}
}
